/* ============================================================
   FRM Flooring Product V2 — colour-variant sync

   frm-flooring-product.js (shared with the original template)
   overwrites #frm-fp-variant-id on every calculator keystroke,
   resolving the variant by purchase mode (SQM / Room Size) — it
   has no concept of colour. An earlier version of this fix tried
   to win that race with a capture-phase submit listener; that
   depends on exact event-timing assumptions holding in every
   browser, and evidently didn't hold reliably in practice (wrong
   colour still reached the cart).

   This version is timing-independent: it intercepts every write to
   #frm-fp-variant-id's `value` property itself. However many times,
   and in whatever order, the shared script (or anything else) tries
   to set that field, the colour actually selected in the gallery
   always wins — there's no race to lose.
   ============================================================ */
(function () {
  "use strict";

  var input = document.getElementById("frm-fp-variant-id");
  if (!input) return;

  var nativeDescriptor = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, "value");
  var selectedVariantId = null;

  function setReal(v) {
    nativeDescriptor.set.call(input, v);
  }

  Object.defineProperty(input, "value", {
    configurable: true,
    enumerable: true,
    get: function () { return nativeDescriptor.get.call(input); },
    set: function (v) {
      /* Once a colour has been resolved, every write — from anywhere —
         is coerced to that variant id instead of whatever was passed. */
      setReal(selectedVariantId || v);
    }
  });

  function selectColour(variantId) {
    if (!variantId) return;
    selectedVariantId = String(variantId);
    setReal(selectedVariantId);
  }

  document.addEventListener("frm:gallery:colourchange", function (e) {
    if (e.detail && e.detail.variantId) selectColour(e.detail.variantId);
  });

  /* Because this script and frm-flooring-gallery.js are both deferred,
     the gallery's *first* colourchange dispatch (fired synchronously
     during its own script execution) happens before the listener above
     is even registered — deferred scripts run in document order, and
     the gallery script runs first. So on load we can't rely on catching
     that event; read the gallery's current state directly once here. */
  function initFromGallery() {
    if (!window.FRM_GALLERY_API) return;
    var data = window.FRM_GALLERY_API.getData();
    var current = data && data[window.FRM_GALLERY_API.getColourIdx()];
    if (current && current.variantId) selectColour(current.variantId);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initFromGallery);
  } else {
    initFromGallery();
  }
})();

/* ============================================================
   Standalone Room Calculator (Room Calculator tab)

   Purely informational — helps a customer work out total area
   across multiple rooms. Deliberately NOT wired to the hidden
   variant/quantity fields or the Add to Cart form: it doesn't
   place an order, it just tells the customer what number to type
   into the real SQM calculator beside Add to Cart. Independent
   element ids (rc-*) keep it isolated from the shared calculator
   script's ffc-* ids.
   ============================================================ */
(function () {
  "use strict";

  var roomsList  = document.getElementById("rc-rooms-list");
  var addRoomBtn = document.getElementById("rc-add-room");
  var resultEl   = document.getElementById("rc-result");
  if (!roomsList || !addRoomBtn || !resultEl) return;

  var packCoverage = (window.FRM_FLOOR_CALC && parseFloat(window.FRM_FLOOR_CALC.sqmPerBox)) || 0;
  var counter = 0;

  function updateRoomArea(div) {
    var inputs = div.querySelectorAll(".rc-dim");
    var l = parseFloat(inputs[0] && inputs[0].value) || 0;
    var w = parseFloat(inputs[1] && inputs[1].value) || 0;
    var chip = div.querySelector(".rc-room-area");
    if (chip) chip.textContent = (l > 0 && w > 0) ? (l * w).toFixed(2) + " m²" : "";
  }

  function renderResult() {
    var total  = 0;
    var hasAny = false;
    roomsList.querySelectorAll(".frm-calc__room").forEach(function (room) {
      var inputs = room.querySelectorAll(".rc-dim");
      var l = parseFloat(inputs[0] && inputs[0].value) || 0;
      var w = parseFloat(inputs[1] && inputs[1].value) || 0;
      if (l > 0 && w > 0) { total += l * w; hasAny = true; }
    });

    if (!hasAny) { resultEl.innerHTML = ""; return; }

    total = parseFloat(total.toFixed(3));
    var html = '<div class="calc-result">' +
      '<div class="calc-result-row"><span class="calc-result-label">Total Area</span>' +
      '<span class="calc-result-value">' + total.toFixed(2) + " m²</span></div>";
    if (packCoverage > 0) {
      var packs = Math.ceil(total / packCoverage);
      html += '<div class="calc-result-row calc-result-row--total"><span class="calc-result-label">Packs Required</span>' +
        '<span class="calc-result-value">' + packs + "</span></div>";
    }
    html += "</div>";
    resultEl.innerHTML = html;
  }

  function addRoom() {
    counter++;
    var div = document.createElement("div");
    div.className = "frm-calc__room";
    div.innerHTML =
      '<span class="frm-calc__room-label">Room ' + counter + "</span>" +
      '<input class="frm-calc__room-input rc-dim" type="number" min="0.01" step="0.01" placeholder="Length (m)" aria-label="Length m">' +
      '<input class="frm-calc__room-input rc-dim" type="number" min="0.01" step="0.01" placeholder="Width (m)" aria-label="Width m">' +
      '<span class="frm-calc__room-area rc-room-area"></span>' +
      '<button class="frm-calc__room-remove" type="button" aria-label="Remove">&times;</button>';

    div.querySelectorAll(".rc-dim").forEach(function (inp) {
      inp.addEventListener("input", function () { updateRoomArea(div); renderResult(); });
    });
    div.querySelector(".frm-calc__room-remove").addEventListener("click", function () {
      div.remove();
      renderResult();
    });

    roomsList.appendChild(div);
  }

  addRoomBtn.addEventListener("click", addRoom);
  addRoom(); /* start with one room row */
})();
